export const normalizeVerifyStampValue = (value) => {
  if (value === undefined || value === null) {
    return "";
  }
  return String(value).trim();
};

export const hasVerifyStampValue = (value) => {
  const normalized = normalizeVerifyStampValue(value);
  return (
    normalized !== "" &&
    normalized.toLowerCase() !== "n/a" &&
    normalized !== "<<None>>"
  );
};

const comparableVerifyStampValue = (value) =>
  normalizeVerifyStampValue(value).toLowerCase();

export const getVerifyStampTransactionHash = (stamp = {}) =>
  normalizeVerifyStampValue(stamp?.transactionHash ?? stamp?.transaction_hash);

export const getVerifyStampCollectionCid = (stamp = {}) =>
  normalizeVerifyStampValue(
    stamp?.collection_hash ??
      stamp?.collectionCid ??
      stamp?.collection_cid ??
      stamp?.setCid ??
      stamp?.set_cid,
  );

export const buildVerifyStampPath = ({
  objectCid,
  transactionHash,
  collectionCid,
} = {}) => {
  const params = new URLSearchParams();

  if (hasVerifyStampValue(objectCid)) {
    params.set("cid", normalizeVerifyStampValue(objectCid));
  }
  if (hasVerifyStampValue(transactionHash)) {
    params.set("transaction_hash", normalizeVerifyStampValue(transactionHash));
  }
  if (hasVerifyStampValue(collectionCid)) {
    params.set("collection_cid", normalizeVerifyStampValue(collectionCid));
  }

  const queryString = params.toString();
  return queryString ? `/verify/?${queryString}` : "/verify/";
};

export const buildVerifyStampUrl = (stampData = {}, origin = "") => {
  const path = buildVerifyStampPath(stampData);
  if (!origin) {
    return path;
  }
  return `${origin.replace(/\/$/, "")}${path}`;
};

export const selectVerifyStamp = (
  stampList,
  { transactionHash, collectionCid } = {},
) => {
  if (!Array.isArray(stampList) || stampList.length === 0) {
    return null;
  }

  if (!hasVerifyStampValue(transactionHash)) {
    return stampList[0];
  }

  const targetTransactionHash = comparableVerifyStampValue(transactionHash);
  const targetCollectionCid = comparableVerifyStampValue(collectionCid);
  const shouldMatchCollection = hasVerifyStampValue(collectionCid);

  return (
    stampList.find((stamp) => {
      const stampTransactionHash = comparableVerifyStampValue(
        getVerifyStampTransactionHash(stamp),
      );
      const stampCollectionCid = comparableVerifyStampValue(
        getVerifyStampCollectionCid(stamp),
      );
      const transactionMatches = stampTransactionHash === targetTransactionHash;

      if (!shouldMatchCollection) {
        return transactionMatches;
      }

      return transactionMatches && stampCollectionCid === targetCollectionCid;
    }) || null
  );
};
